@if (pageContent) {
    <div>
        @if (pageContent.Header) {
            <app-header [headerContent]="pageContent.Header" />
        }
        <div
            class="{{ pageContent.CustomCSS }} DTX_PAGE_TYPE_{{ this.pageContent.PageType.toUpperCase() }} DTX_CONTENT_PAGE {{
                pageType ? 'container' : ''
            }}"
        >
        <!-- TODO handle top menu and maybe one day right menu Newsletters -->
            <div [ngClass]="isNewsletter() ? 'row m-0 DTX_NEWSLETTER_CONTAINER' : ''">
                @if (isLeftMenuNewsletter()) {
                    <app-newsletter-menu
                        [newsletterContent]="pageContent"
                        [pageSlug]="pageContent.Slug ?? ''"
                        class="col-sm-12 col-md-12 col-lg-3 p-0 DTX_NEWSLETTER_TAB"
                    />
                }
                @if (isTopMenuNewsletter()) {
                    <app-newsletter-menu
                        [newsletterContent]="pageContent"
                        [pageSlug]="pageContent.Slug ?? ''"
                        class="col-sm-12 col-md-12 p-0 DTX_NEWSLETTER_TAB"
                    />
                }
                <div class="{{ isLeftMenuNewsletter() ? 'col-sm-12 col-md-12 col-lg-9 NEWSLETTER_CONTAINER' : '' }}">
                    @for (content of this.pageContent.PageContent; track content.Id) {
                        <app-content [content]="content" [newsletterStyling]="isNewsletter()"
                                     [StyleCode]="pageContent.StyleCode ?? ''" />
                    }
                </div>
            </div>
        </div>
        @if (pageContent.Footer) {
            <app-footer [footerContent]="pageContent.Footer" />
        }
    </div>
}
